import { ArrowUpRight } from "lucide-react";
import { ReactComponent as WhatsAppLogo } from "@/assets/icons/whatsapp.svg";
import { WHATSAPP_URL } from "@/lib/content";

const styles = {
  solid: "border border-[#221e1b] bg-[#221e1b] text-[#faf5ee] hover:bg-[#3a322c]",
  outline: "border border-[#221e1b]/25 text-[#221e1b] hover:border-[#a8792a] hover:text-[#7a5615]",
  light: "border border-[#faf5ee]/25 bg-[#faf5ee] text-[#221e1b] hover:bg-[#efe6d8]",
};

export const WhatsAppButton = ({ children = "Chat on WhatsApp", variant = "solid", className = "", testId }) => (
  <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-testid={testId}
    className={`group inline-flex min-h-12 max-w-full items-center justify-center gap-2.5 rounded-full px-6 py-3.5 text-center text-sm font-semibold leading-snug transition-colors duration-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#7a5615] sm:text-base ${styles[variant]} ${className}`}>
    <WhatsAppLogo aria-hidden="true" focusable="false" className="h-5 w-5 shrink-0" />
    <span>{children}</span>
    <ArrowUpRight aria-hidden="true" className="h-4 w-4 shrink-0 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
  </a>
);
